import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
`;

const Form = styled.form`
  display: flex;
  width: 100%;
  margin-top: 20px;
`;

export { Container, Form };
